import { useState, useEffect, useMemo } from 'react';
import API_REST from '../../../api-rest-uruk';
import { getSchema } from './utils';
import { useSelector } from 'react-redux';
import { getWhitelist } from '../../Notification/CreateNotification/utils';

const useGetSchema = (formData) => {
  const { type } = formData;
  const [ templates, setTemplates ] = useState(undefined);
  const [ loading, setLoading ] = useState(false);
  const appConfig = useSelector((state) => state.config);
  const { activeContext, extraConfig } = appConfig;

  const ctxExtraConfig = useMemo(() => JSON.parse(activeContext.extraConfig.data), [activeContext]);

  const whitelist = useMemo(() => {
    const appExtraConfig = JSON.parse(extraConfig.data);
    return getWhitelist(formData.type, appExtraConfig, ctxExtraConfig);
  }, [formData.type]);

  const schema = getSchema(whitelist, ctxExtraConfig.emailSignature);

  if (templates !== undefined) {
    schema.properties.templateId.enum = templates.map((template) => template.templateid || undefined);
  } else {
    delete schema.properties.template;
  }

  const fetchData = async (type) => {
    let queryParam = '';
    if (type === 'email') {
      queryParam = 'html';
    } else if (type === 'sms') {
      queryParam = 'text';
    }
    const templates = await API_REST.getTemplatesNotification(queryParam);
    if (templates.data) {
      setTemplates(templates.data);
    } else {
      setTemplates(undefined);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (formData.type) {
      fetchData(formData.type);
    }
  }, [type]);

  return [schema, templates, loading];
};

export default useGetSchema;
